import { useMemo } from 'react';

import InsightItem from '../InsightsItem';

const InsightsStage = ({
  groupedHighs,
  onUpdate,
  isEdit,
  reportId,
  isReportAutomated,
}) => {
  const isEmpty = useMemo(() => {
    return !groupedHighs.length;
  }, [groupedHighs]);

  return (
    <div className="insights-section">
      <div className={'highlights-list-container mt-5 flex flex-col relative'}>
        <div
          className={`highlights-list ${
            isEmpty ? 'empty' : ''
          } report-list w-full flex flex-col`}
        >
          {!isEmpty ? (
            groupedHighs.map((highlight, i) => (
              <InsightItem
                highlight={highlight}
                key={`${highlight.familyName}${i}`}
                onUpdate={onUpdate}
                isEdit={isEdit}
                reportId={reportId}
                isReportAutomated={isReportAutomated}
              />
            ))
          ) : (
            <div className="empty-text mb-8 text-center">
              No insights were found
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InsightsStage;
